const carouselData = [
  {
    title: '黑料每日大赛 · 七月精选',
    desc: '本月最火爆的每日大赛合集，12个赛段精彩对决一网打尽，点击查看完整赛事回顾与热门选手表现。',
    tag: '本月主打',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20competition%20stage%20with%20dramatic%20spotlight%2C%20dark%20atmospheric%20background%2C%20golden%20trophy%20centerpiece%2C%20cinematic%20lighting%20with%20warm%20crimson%20accents%2C%20grand%20event%20aesthetic&width=700&height=450&seq=carousel-01-contest&orientation=landscape',
  },
  {
    title: '明星八卦 · 七月最全梳理',
    desc: '七月明星圈大事全回顾，从恋情曝光到合约纠纷，一篇看懂本月娱乐圈风云变幻。',
    tag: '明星专题',
    img: 'https://readdy.ai/api/search-image?query=Celebrity%20red%20carpet%20event%20atmosphere%2C%20paparazzi%20camera%20flashes%2C%20glamorous%20entertainment%20scene%2C%20dark%20elegant%20background%2C%20Hollywood%20style%20photography%20with%20warm%20golden%20lighting&width=700&height=450&seq=carousel-02-celebrity&orientation=landscape',
  },
  {
    title: '综艺名场面 · 年度经典回顾',
    desc: '那些让全网笑到停不下来的综艺名场面，从搞笑片段到感人瞬间，都是经典中的经典。',
    tag: '综艺专题',
    img: 'https://readdy.ai/api/search-image?query=Television%20show%20studio%20with%20colorful%20stage%20setup%2C%20entertainment%20variety%20program%20atmosphere%2C%20bright%20warm%20lighting%2C%20professional%20broadcast%20production%2C%20lively%20energetic%20vibe&width=700&height=450&seq=carousel-03-variety&orientation=landscape',
  },
  {
    title: '网红翻车 · 年度大型盘点',
    desc: '盘点那些年网红界的经典翻车现场，从带货事故到人设崩塌，每一件都堪称教科书级别。',
    tag: '网红专题',
    img: 'https://readdy.ai/api/search-image?query=Social%20media%20livestreaming%20studio%20setup%2C%20professional%20ring%20light%20and%20camera%20equipment%2C%20modern%20content%20creation%20space%2C%20dramatic%20lighting%20contrast%2C%20trendy%20influencer%20aesthetic%20with%20warm%20accents&width=700&height=450&seq=carousel-04-influencer&orientation=landscape',
  },
  {
    title: '影视吐槽 · 导演看了都沉默',
    desc: '年度影视剧穿帮镜头与剧情bug大合集，犀利吐槽让你笑到肚子疼，导演看了都忍不住点赞。',
    tag: '影视专题',
    img: 'https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20cinema%20camera%2C%20director%20chair%2C%20movie%20clapperboard%2C%20dark%20atmospheric%20studio%20lighting%2C%20Hollywood%20filmmaking%20aesthetic%2C%20dramatic%20shadows&width=700&height=450&seq=carousel-05-film&orientation=landscape',
  },
  {
    title: '平台风云 · 短视频格局之变',
    desc: '深度解析短视频平台最新竞争格局，创作者迁移潮背后的商业逻辑，谁能笑到最后？',
    tag: '行业专题',
    img: 'https://readdy.ai/api/search-image?query=Digital%20media%20and%20technology%20concept%2C%20smartphone%20displaying%20social%20media%20feeds%2C%20dark%20futuristic%20background%2C%20glowing%20warm%20interface%20elements%2C%20modern%20tech%20workspace%20aesthetic&width=700&height=450&seq=carousel-06-platform&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600">
            深度策划的焦点专题，每一期都值得收藏细品
          </p>
        </div>

        {/* All 6 items displayed at once, no carousel behavior */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 border border-background-300/30 rounded-xl overflow-hidden transition-all hover:border-primary-500/20 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 group-hover:text-primary-400 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}